<template>
  <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 20C11.1 20 12 19.1 12 18L11.99 14.82C11.99 14.29 11.78 13.79 11.41 13.41L8 10L11.41 6.57C11.78 6.2 11.99 5.69 11.99 5.16L12 2C12 0.9 11.1 0 10 0H2C0.9 0 0 0.9 0 2V5.16C0 5.69 0.21 6.2 0.58 6.58L4 10L0.59 13.4C0.21 13.78 0 14.29 0 14.82V18C0 19.1 0.9 20 2 20H10ZM2 5.09V3C2 2.45 2.45 2 3 2H9C9.55 2 10 2.45 10 3V5.09C10 5.36 9.89 5.61 9.71 5.8L6 9.5L2.29 5.79C2.11 5.61 2 5.35 2 5.09Z"
      fill="#656262"
    />
  </svg>
</template>
